import * as Yup from 'yup';

export const lineSchema = Yup.object().shape({
  protheusCode: Yup.string().required('Código é obrigatório.'),
  description: Yup.string().required('Descrição é obrigatória.'),
  descriptionAlias: Yup.string()
});